import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { SensorDataModel } from '../../models/sensor.model';
import { SensorsHttpService } from '../../services/sensors-http.service';

require('./agent-temperature.scss');
@Component({
  standalone: false,
  selector: 'app-agent-temperature',
  templateUrl: './agent-temperature.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentTemperatureComponent implements OnChanges {

  @Input() logisticsVehicleId: string;

  sensorsData: SensorDataModel[] = [];
  loading: boolean = false;
  activeSensor: SensorDataModel | null = null;

  constructor(
    @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
    @Inject(SensorsHttpService) private sensorsHttpService: SensorsHttpService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.logisticsVehicleId && this.logisticsVehicleId) {
      this.loadData();
    }
  }

  private loadData(): void {
    this.loading = true;
    
    this.sensorsHttpService.getSensors('LogisticsVehicle', this.logisticsVehicleId)
      .subscribe({
        next: (sensors) => {
          this.sensorsData = sensors || [];
          this.loading = false;
          this.cdr.markForCheck();
        },
        error: (err) => {
          console.error('Failed to load sensor data:', err);
          this.sensorsData = [];
          this.loading = false;
          this.cdr.markForCheck();
        }
      });
  }

  getLastUpdate(sensor: SensorDataModel): string {
    if (!sensor?.updatedTime) {
      return '---';
    }
    const date = new Date(sensor.updatedTime);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${month}/${day} ${hours}:${minutes}`;
  }

  getSensorStatus(sensor: SensorDataModel): string {
    const data = sensor.data;
    if (data.minThreshold !== undefined && data.maxThreshold !== undefined && data.minThreshold !== null && data.maxThreshold !== null) {
      if (data.temperature > data.maxThreshold) {
        return 'sensor-violation-high';
      } else if (data.temperature < data.minThreshold) {
        return 'sensor-violation-low';
      } else {
        return 'sensor-normal';
      }
    }
    return 'sensor-off';
  }

  getSensorColor(sensor: SensorDataModel): string {
    const status = this.getSensorStatus(sensor);
    switch (status) {
      case 'sensor-violation-high':
        return '#FF6B6D';
      case 'sensor-violation-low':
        return '#266AFF';
      case 'sensor-off':
        return '#7E7E7E';
      default:
        return '#4ABF4A';
    }
  }

  setActiveSensor(sensor: SensorDataModel): void {
    this.activeSensor = sensor;
  }

  shouldDisplay(): boolean {
    return !!this.logisticsVehicleId && this.sensorsData.length > 0;
  }
}
